export default __webpack_public_path__ + "static/media/Colors_01.47d176cc.png";